<app-loading
  [hidden]="!(combinedLoadingOptsViewModel.isLoading$ | push)"
  [options]="combinedLoadingOptsViewModel.loadingOpts$ | push">
</app-loading>

<lib-reactive-form-merge-groups
  #formCapture
  [mergeKey]="mergeAndDispersedKey"
  (formsAutoSubmitted$)="viewModel.saveTemplate(true)"
  (formsSubmitted$)="viewModel.saveTemplate(false)"
  (disableSubmit$)="viewModel.setAutoSaveTimer($event)"
  (unsavedChanges$)="viewModel.setUnsavedChanges($event)">
</lib-reactive-form-merge-groups>

<app-edit-menu-container>
  <app-edit-template-shelf-talker-menu-header
    [crumbs]="viewModel.crumbs$ | push"
    [formPristine]="formCapture.allPristine$ | push"
    [unsavedChanges]="formCapture.unsavedChanges$ | push"
    [formAutoSubmitted]="formCapture.formsAutoSubmitted$ | push"
    [formDisableSubmit]="formCapture.disableSubmit$ | push"
    [formErrorMessages]="formCapture.errorMessages$ | push"
    [formHasErrors]="formCapture.hasErrors$ | push"
    (submitForms)="viewModel.saveIntercept($event)">
  </app-edit-template-shelf-talker-menu-header>

  <app-edit-template-locations-section
    [mergeKey]="mergeAndDispersedKey"
    [template]="viewModel.activeTemplate$ | push"
    (changedRequiredTemplateIds)="viewModel.connectToChangedRequiredTemplateIds($event)">
  </app-edit-template-locations-section>

  <app-edit-shelf-talker-brands-menu-body
    [templateMode]="true"
    [mergeKey]="mergeAndDispersedKey"
    [formHasErrors]="formCapture.hasErrors$ | push"
    [formPristine]="formCapture.allPristine$ | push"
    [formAutoSubmitted]="formCapture.formsAutoSubmitted$ | push"
    (submitForms)="formCapture.submitForms($event)">
  </app-edit-shelf-talker-brands-menu-body>

  <app-edit-template-shelf-talker-menu-footer
    [formAutoSubmitted]="formCapture.formsAutoSubmitted$ | push"
    [formDisableSubmit]="formCapture.disableSubmit$ | push"
    [formErrorMessages]="formCapture.errorMessages$ | push"
    [formHasErrors]="formCapture.hasErrors$ | push"
    [formPristine]="formCapture.allPristine$ | push"
    (submitForms)="viewModel.saveIntercept($event)"></app-edit-template-shelf-talker-menu-footer>
</app-edit-menu-container>
